// extracted by mini-css-extract-plugin
module.exports = {"recentPosts":"LinkBar-module--recent-posts--1-Bpn","sectionHeader":"LinkBar-module--section-header--a2veT","links":"LinkBar-module--links--JT0rG"};